import { Injectable } from "@angular/core";
import { City } from "../../models/domains/pbm/state/city";
import { StateAcronym } from "../../models/domains/pbm/state/state-acronym";
import { StateRepository } from "../../repositories/pbm/state.repository";
import { ZipCodeIntegration } from "../../models/domains/pbm/state/zip-code-integration.model.ts";

@Injectable({ providedIn: "root" })
export class StateService {
  constructor(private stateRepository: StateRepository) {}

  public async getStates(): Promise<StateAcronym[]> {
    return await this.stateRepository.getStates();
  }

  public async getCityByStateAcronym(stateAcronym: StateAcronym): Promise<City[]> {
    return await this.stateRepository.getCityByStateAcronym(stateAcronym);
  }

  public async getZipCodeIntegration(zipCode: string): Promise<ZipCodeIntegration> {
    return await Promise.resolve(this.stateRepository.getZipCode(zipCode));
  }
}
